// extracted by mini-css-extract-plugin
export default {"root":"VuZtj0fO","reverse":"_1ojZ5W2g","avatar":"_2NVP2Moj","messages":"_34dEwJaP"};